/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbSyncLog {
    getFixupPrototypeFunction() { return ServiceNowCmdbSyncLog.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbSyncLog>): ServiceNowCmdbSyncLog {
        let obj = Object.assign(new ServiceNowCmdbSyncLog(), model);
        ServiceNowCmdbSyncLog.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbSyncLog>): ServiceNowCmdbSyncLog {
        if (!model) return null;
        return ServiceNowCmdbSyncLog.newInstance(<ServiceNowCmdbSyncLog> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbSyncLog) {
        if (!obj) return;

        models.ServiceNowCmdbSyncLog.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbSyncLog): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbSyncLog.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.sync_time === "string") {
            this.sync_time = new Date(<string><any>this.sync_time);
        }
    }

    /**
     * Identifier for the ServiceNow Configuration Item (CI) being synchronized.
     */
    ci: string;

    /**
     * Unique identifier for the synchronized resource.
     */
    resource_id: string;

    /**
     * Synchronized resource type.
     */
    resource_type: string;

    /**
     * Type of synchronization operation, which can be create, update, or delete.
     */
    action: string;

    /**
     * Status of the synchronization operation, indicating success or failure.
     */
    status: string;

    /**
     * Type or category of the cloud resource being synchronized.
     */
    service: string;

    /**
     * ServiceNow URL link to access the specific Configuration Item (CI).
     */
    sys_id_link: string;

    /**
     * The request body sent when creating a Configuration Item (CI).
     */
    target_args: string;

    /**
     * Timestamp representing the time when the resource synchronization occurred.
     */
    sync_time: Date;

}
